import { Files } from './files';
import { User } from './user';

export type Blog = {
   _id: string;
   slug: string;
   deletedAt: Date | null;
   tags: string[];
   title: string;
   body: string;
   views: number;
   feature_image: Files;
   author: User;
   publishedAt: Date;
   createdAt: string;
   updatedAt: string;
   __v: number;
   status: TBlogStatus;
};
export const BlogStatus = { DRAFT: 'draft', PUBLISHED: 'published' } as const;

export type TBlogStatus = (typeof BlogStatus)[keyof typeof BlogStatus];
